import {MetaTitleDesc} from "./meta";
import DocumentMeta from "react-document-meta";
import {Link} from "react-router-dom";

export default () => {
    const title = 'Брестская область на карте';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <img src={require('./img/logo_maps.gif')}/>
                    <ul>
                        <li><Link to='/maps-bo'>Брестская область</Link></li>
                        <li><Link to='/maps-brest-region'>Брестский район</Link></li>
                        <li><Link to='/maps-brest-town'>Город Брест</Link></li>
                        <li><Link to='/maps-baranoviczi-region'>Барановичский район</Link></li>
                        <li><Link to='/maps-baranoviczi-town'>Город Барановичи</Link></li>
                        <li><Link to='/maps-bereza-region'>Березовский район</Link></li>
                        <li><Link to='/maps-gancewiczi-region'>Ганцевичский район</Link></li>
                        <li><Link to='/maps-drogiczin-region'>Дрогичинский район</Link></li>
                        <li><Link to='/maps-zabinka-region'>Жабинковский район</Link></li>
                        <li><Link to='/maps-ivanovo-region'>Ивановский район</Link></li>
                        <li><Link to='/maps-ivacewiczi-region'>Ивацевичский район</Link></li>
                        <li><Link to='/maps-kamenec-region'>Каменецкий район</Link></li>
                        <li><Link to='/maps-kobrin-region'>Кобринский район</Link></li>
                        <li><Link to='/maps-luninec-region'>Лунинецкий район</Link></li>
                        <li><Link to='/maps-liachoviczi-region'>Ляховичский район</Link></li>
                        <li><Link to='/maps-malorita-region'>Малоритский район</Link></li>
                        <li><Link to='/maps-pinsk-region'>Пинский район</Link></li>
                        <li><Link to='/maps-pinsk-town'>Город Пинск</Link></li>
                        <li><Link to='/maps-pruzany-region'>Пружанский район</Link></li>
                        <li><Link to='/maps-stolin-region'>Столинский район</Link></li>
                        <li><Link to='/maps-sez'>Свободная экономическая зона "Брест"</Link></li>
                        <li><Link to='/maps-republicofbelarus'>Республика Беларусь</Link></li>
                        <li><Link to='/maps-europe'>Брестская область в Европе</Link></li>
                    </ul>
                </div>
            </div>
        </>
    );
}